export default __webpack_public_path__ + "static/media/home-bg1.0be45ce0.png";